const WRITER_API_ROUTE = `${process.env.REACT_APP_WRITER_API_ROUTE}`;
const LICENSE_CHAT_API_ROUTE = `${process.env.REACT_APP_CHAT_API_ROUTE}/license`;

const ACCOUNT_API_ROUTE = `${WRITER_API_ROUTE}/account`
export const ACTIVATE_ACCESS_API_ROUTE = `${ACCOUNT_API_ROUTE}/activate-access`;
export const GET_LICENSE_API_ROUTE = `${ACCOUNT_API_ROUTE}/get-license`;
export const UPDATE_LICENSE_API_ROUTE = `${LICENSE_CHAT_API_ROUTE}/update-license`;
export const GET_LICENSE_USAGE_API_ROUTE = `${LICENSE_CHAT_API_ROUTE}/get-license-usage`;